import {Button} from 'antd';
import React from 'react';

const InsertButton: React.FC<{onClick: (e: any) => void; text?: string}> = ({
  onClick,
  text
}) => {
  const textValue = text ?? 'Insert';

  return (
    <Button onClick={onClick} className="insert-btn">
      <div style={{width: 'fit-content'}}>{textValue}</div>
    </Button>
  );
};

export default InsertButton;
